<!--
 * @Author: lwk
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-03-07 11:32:26
 * @Description: 请填写简介
-->
<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-01-25 10:58:07
 * @Description: 日行一善s
-->
<template>
  <div class="publicStatic">
    <div>
      <el-row
        :gutter="12"
        type="flex"
        class="row-bg"
        justify="space-around"
        style="margin-bottom: 10px;"
      >
        <el-col :span="8">
          <div style="display: flex;">
            <el-input
              size="mini"
              placeholder="请输入提交人"
              v-model="form.createName"
              style="margin-right: 6px;"
            ></el-input>
            <el-input
              size="mini"
              placeholder="请输入所属部门"
              v-model="form.deptName"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row type="flex" class="row-bg">
            <el-date-picker
              style="margin-right: 6px;"
              v-model="dateTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :clearable="false"
            >
            </el-date-picker>
            <el-select
              v-model="form.remark"
              size="mini"
              :popper-append-to-body="false"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-row>
        </el-col>
        <el-col :span="4">
          <div style="display: flex;align-items: center;">
            <el-button
              @click="searchData"
              size="mini"
              type="primary"
              icon="el-icon-search"
              >查询</el-button
            >
            <el-button
              @click="reset"
              size="mini"
              type="primary"
              icon="el-icon-search"
              >重置</el-button
            >
            <el-button @click="exportData" size="mini" type="primary"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="tableData" style="width: 100%;height: 100%;">
          <el-table-column
            label="序号"
            type="index"
            width="100"
            align="center"
          />
          <el-table-column prop="flow_create_time" label="发送日期" align="center" />
          <el-table-column prop="create_name" label="提交人" align="center" />
          <el-table-column prop="dept_name" label="所属部门" align="center" />
          <el-table-column prop="sys_leader" label="直接上级" align="center" />
          <el-table-column
            prop="rq_comment_flag"
            label="是否已点评"
            align="center"
          />
          <el-table-column
            prop="flow_spend_time"
            label="总流程耗时（h）"
            align="center"
          />
        </el-table>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="checkPage"
          >
          </el-pagination>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getuserList, expUserList } from "@/api/dayqing";
import moment from "moment";

export default {
  name: "DayQingData",
  data() {
    return {
      form: {
        deptName: "",
        createName: "",
        beginTime: "",
        endTime: "",
        remark: ""
      },
      dateTime: [
        moment()
          .subtract(1, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "days")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],
      dateType: "yesterDay",
      tableData: [],
      tableDataPerson: [],
      pageType: {
        pageNum: 1,
        pageSize: 10
      },
      total: undefined
    };
  },
  mounted() {
    this.getuserList();
  },
  methods: {
    searchData() {
      this.getuserList();
    },
    async getuserList() {
      this.form.beginTime = this.dateTime[0];
      this.form.endTime = this.dateTime[1];
      const { code, rows, total } = await getuserList({
        ...this.form,
        ...this.pageType
      });
      if (code != 0) return;
      this.tableData = rows;
      this.total = total;
    },
    checkPage(val) {
      this.pageType.pageNum = val;
      this.getuserList();
    },
    exportData() {
      expUserList(this.form).then(res => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("id", "pdfID");
        link.setAttribute("download", `数据统计.xls`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      });
    },
      // 重置
  reset() {
    Object.keys(this.form).forEach(key => {
      this.form[key] = "";
      this.getuserList();
    });
  }
  },

};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/DayQing/DayQingData.vue